$.fn.equalHeights = (tag)->
  currentTallest = 0
  $(@).children(tag).each (i)->
    currentTallest = $(@).height() if $(this).height() > currentTallest
  currentTallest = currentTallest+"px"
  $(@).children(tag).css 'min-height': currentTallest

overlay_box = ->
  # Funzione che muove le immagini della photo gallery
  # IMPORTANTE!! Funziona solo su classe .image-overlay
  $fPhoto = $('.image-overlay').parent()
  $fPhoto.css 'background-color','#000000'
  $('.zoom-icon, .more-icon').css
    'opacity':'0'
    'visibility':'visible'

  $hPhoto = $fPhoto.height()
  $top = ($hPhoto-46)/2
  $($fPhoto).find('a.zoom-icon').css 'top', $top
  $($fPhoto).find('a.more-icon').css 'top', $top

  $wPhoto = $fPhoto.width()
  $zoom_left = ($wPhoto-100)/2
  $more_left = $zoom_left+52
  $($fPhoto).find('a.zoom-icon').css 'left', $zoom_left
  $($fPhoto).find('a.more-icon').css 'left', $more_left

  $fPhoto.hover ->
    $(@).stop(true, true).animate({top: -10}, 500).find('img').stop(true, true).animate({opacity: 0.7}, 500)
    $(@).find('.zoom-icon').stop(true, true).animate({opacity: 1, left: $zoom_left}, 400)
    $(@).find('.more-icon').stop(true, true).animate({opacity: 1, left: $more_left}, 400)
  , ->
    $(@).find('.zoom-icon').stop(true, true).animate({opacity: 0, left: $zoom_left}, 400)
    $(@).find('.more-icon').stop(true, true).animate({opacity: 0, left: $more_left}, 400)
    $(@).stop(true, true).animate({top: 0}, 500).find('img').stop(true, true).animate({opacity: 1}, 500)

pg_nav = ->
  $(".pg-next").hover ->
    $(".pg-prev").animate({marginRight: "774px"}, 250)
    $(@).animate({opacity: .5}, 250)
  , ->
    $(".pg-prev").stop(true, true).animate({marginRight: "769px"}, 250)
    $(@).animate({opacity: 1}, 250)

  $(".pg-prev").hover ->
    $(@).animate({marginLeft: "75px", marginRight: "774px", opacity: .5}, 250)
  , ->
    $(@).stop(true, true).animate({marginLeft: "80px", marginRight: "769px",  opacity: 1}, 250)

center_img_o = (obj,nh)->
  w = obj.width()
  ml = Math.ceil((w-nh)/2)
  ml = ml*-1;
  ml1 = ml+'px';
  obj.css 'marginLeft' : ml1

center_img_v = (obj,nh)->
  h = obj.height()
  mt = Math.ceil((h-nh)/2)
  mt = mt*-1
  mt1 = mt+'px'
  obj.css 'marginTop' : mt1

setSizeSite = ->
  hWindow = jQuery(window).height()
  wWindow = jQuery(window).width()
  wDocument = jQuery(document).width()
  hBody = jQuery("body").height()
  elms = jQuery("body,html")
  if hBody <= hWindow
    elms.css("height","100%")
  else
    elms.css("height","auto")
  if wWindow < wDocument
    elms.css("width",wDocument+"px")
  else
    elms.css("width","auto")

$ ->
  slideshow()

  $('#games-bar').jcarousel
    vertical: false
    animation: 500
    scroll: 1
    buttonPrevHTML: '<div class="jcarousel-prev jcarousel-prev-horizontal" style="display: block;" disabled="disabled">&lang;</div>'
    buttonNextHTML: '<div class="jcarousel-next jcarousel-next-horizontal" style="display: block;" disabled="disabled">&rang;</div>'

  $('#matches-bar').jcarousel
    vertical: false
    animation: 500
    scroll: 1
    buttonPrevHTML: '<div class="jcarousel-prev jcarousel-prev-horizontal" style="display: block;" disabled="disabled">&lang;</div>'
    buttonNextHTML: '<div class="jcarousel-next jcarousel-next-horizontal" style="display: block;" disabled="disabled">&rang;</div>'

  events_all_page = $('.events-all-page')
  if events_all_page.length > 0

    nLi = $('#events-all li').length
    wUl = (nLi*226)
    $('#events-all').css('width',wUl+'px')

    $('#events-all li').each ->
      img = $(@).find('img')
      img.load ->
        if img.height() < 244
          pTop = Math.floor(244-img.height())/2
          hLink = 246 - pTop
          img.parent('a').css('paddingTop',pTop+'px').css('height',hLink+'px')

    data_json = $('#events-all').data().data_json
    argsCarouselEvents = new Array(3)
    argsCarouselEvents.prevText = data_json.prevText
    argsCarouselEvents.nextText = data_json.nextText
    argsCarouselEvents.todayText = data_json.todayText
    argsCarouselEvents.selector = '#events-all'
    selectedClass = data_json.selectedClass
    normalClass = data_json.normalClass
    carouselEventsAll(data_json.startPoint, argsCarouselEvents)

  contact_page_template = $('.contact-page-template')
  if contact_page_template.length > 0
    $(".contact-page-template-avatarbox").click ->
      contact_id = $(@).data().openbox
      open_box(contact_id) if contact_id

  $("form#search-media").submit (e)->
    removeDefaultValueOnSubmit(@)

  toggle_default_text('#search-query')
  toggle_default_text('#comment')

  zIndexNumber = 1000
  $('#header div, #c-top div').each ->
    $(@).css('zIndex', zIndexNumber)
    zIndexNumber -= 10

  $('.sf-menu').superfish({autoArrows: false, speed: 'fast', dropShadows: 'true'})
  overlay_box()
  pg_nav()

  # $('.h-l-event-imgwrap').each ->
  #   img = $(@).find('img')
  #   img.load ->
  #     h = $(@).height()
  #     w = $(@).width()
  #     if h > w
  #       $(@).css('width','50px')
  #       m = (h*50)/w
  #       m = Math.ceil((m-50)/2)
  #       m = m*-1
  #       m = m+"px"
  #       $(@).css('marginTop',m)
  #     else
  #       $(@).css('height','50px')
  #       m = (w*50)/h
  #       m = Math.ceil((m-50)/2)
  #       m = m*-1
  #       m = m+"px"
  #       $(@).css('marginLeft',m)

  $('#m-right .tabs ul li').each ->
    $(@).on "click", ->
      $('.tab-content').toggle()
      $('#m-right .tabs ul li').toggleClass('selected')

  $('.eq').equalHeights('div')
  $(window).load ->
    center_img_v $('#box-info-item-shop'), 226
    $('.eq').equalHeights('div')

  setSizeSite()

  jCarouselAutoInit('.matches,.games',{
    vertical: false,
    animation: 500,
    scroll: 1,
    buttonPrevHTML: '<div class="jcarousel-prev jcarousel-prev-horizontal" style="display: block;" disabled="disabled">&lang;</div>',
    buttonNextHTML: '<div class="jcarousel-next jcarousel-next-horizontal" style="display: block;" disabled="disabled">&rang;</div>'
  })

  $('*[data-create-onclick]').on "click", (e)->
    parent = $(@).data('create-onclick')
    $link = $(@).parents("li").find('a')
    $link[0].click() if $link[0]

  $('#privacy-policy h3').addClass('box-title')

$(window).load ->
  setSizeSite()

$(window).resize ->
  setSizeSite()

# Customizer
window.htmltorgb = (hex)->
  hex = hex.replace(/^\s*#|\s*$/g, '')
  if (hex.length == 3)
    hex = hex.replace(/(.)/g, '$1$1')
  r = parseInt(hex.substr(0, 2), 16)
  g = parseInt(hex.substr(2, 2), 16)
  b = parseInt(hex.substr(4, 2), 16)
  return [r, g, b]

window.alter_brightness = (hex, percent)->
  rgb = htmltorgb(hex)
  r = rgb[0]
  g = rgb[1]
  b = rgb[2]
  return '#' + ((0 | (1 << 8) + r + (256 - r) * percent / 100).toString(16)).substr(1) + ((0 | (1 << 8) + g + (256 - g) * percent / 100).toString(16)).substr(1) + ((0 | (1 << 8) + b + (256 - b) * percent / 100).toString(16)).substr(1)

window.box_background_color3_backend = (newval)->
  _style1 = "box-shadow: 0px 0px 20px #{newval}!important;"
  _style = "#groups_home ul li .img, #posts_home ul li .img, #events_home ul li .img { #{_style1} }"
  return _style

window.box_background_color4_backend = (newval)->
  _style1 = "box-shadow: inset #{newval} 0px 1px 0 0!important;"
  _style2 = "box-shadow: inset #{newval} 0px -1px 0 0!important;"
  _style3 = "box-shadow: inset #{newval} -1px 0px 0 0!important;"
  _style = "\
    #wrapper.home #content > div:nth-child(odd), #footer, #logo_nav, #logo_nav .sf-menu > li ul li { #{_style1} }\
    .cycle-slideshow_container .cycle-slideshow { #{_style2} }\
    #logo_nav .sf-menu > li { #{_style3} }"
  return _style

window.box_background_color5_backend = (newval)->
  _finalval = alter_brightness(newval, -10)
  _style1 = "background-color: inset #{newval} 0px 1px 0 0!important;"
  _style = "#newsletter-box input[type=submit]:hover, #newsletter-box input[type=submit]:focus { #{_style1} }"
  return _style

$ ->
  if typeof wp != "undefined" and wp.customize
    wp.customize "header", (value)->
      value.bind (newval)->
        if newval==""
          $("#content-img-header").hide()
        else
          $("#content-img-header img").attr('src', newval)
          $("#content-img-header").show()